import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
	IoIosClose,
	IoMdDownload,
	IoMdDoneAll,
	IoMdCreate,
	IoMdCalendar,
	IoMdTrash,
} from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";

const AdvanceShipEdiAddEdit = (props) => {
	let fileName = "";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	const salesData = JSON.parse(localStorage.getItem("advanceShipNotice"));
	fileName = `${outbounddata.VendorName} Monthly Advance Ship Notice (EDI)`;

	const userData = localStorage.getItem("userData");
	const history = useHistory();
	const [sales, setSales] = useState([]);
	const [gridSales, setGridSales] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [showCOnfirm, setShowConfirm] = useState(false);
	const [addshowConfirm, setaddShowConfirm] = useState(false);
	const [gridShow, setGridShow] = useState(false);
	const [sale, setSaleItem] = useState({});
	const [editOrSaveInd, setEditOrSaveInd] = useState(false);
	const [disableSubmit, setSubmitDisable] = useState(false);
	const [addDisableSubmit, setAddSubmitDisable] = useState(false);
	const [showToaster, setShowToaster] = useState(false);
	const [disableSaveAll, setDisableSaveAll] = useState(false);
	const initialvalues = {
		ShippedDate: "",
		ShippedTime: "",
		ShipToName: "",
		CustomerID: "",
		BuyersPartNumber: "",
		PurchaseOrderNumber: "",
		MeasurementQualifier: "",
		MeasurementValue: "",
		MeasurementCode: "",
		ReferenceIdentificationQualifier: "",
		ReferenceIdentificationQualifierNumber: "",
		LineItemCount: "",
	};
	const [newSales, setNewSales] = useState(initialvalues);
	const [editIndex, setEditIndex] = useState();

	const Gridcolumns = [
		{
			Header: "Actions",
			accessor: "accessor",
			disableFilters: true,
			disableSortBy: true,
			width: 130,
			accessor: "accessor",

			Cell: (row) => (
				<Fragment>
					<Button
						variant="link"
						onClick={() => editReport(row)}
						className="grid-action-btn ml-2"
						title="Edit Row"
					>
						<IoMdCreate className="icon" />
					</Button>
					<Button
						variant="link"
						onClick={() => deleteRecord(row)}
						className="grid-action-btn ml-2"
						title="Delete Row"
					>
						<IoMdTrash className="icon fa-icon" />
					</Button>
				</Fragment>
			),
		},
		{
			Header: "Shipped Date",
			accessor: "ShippedDate",
			filter: "ShippedDate",
			sortType: "basic",
			width: 120,
			isMandatory: true,
		},
		{
			Header: "Shipped Time",
			accessor: "ShippedTime",
			filter: "ShippedTime",
			sortType: "basic",
			width: 120,
			isMandatory: true,
		},
		{
			Header: "Ship To Name",
			accessor: "ShipToName",
			filter: "ShipToName",
			sortType: "basic",
			width: 250,
			isMandatory: true,
		},
		{
			Header: "Customer ID",
			accessor: "CustomerID",
			filter: "CustomerID",
			sortType: "basic",
			width: 120,
			isMandatory: true,
		},
		{
			Header: "Buyers Part Number",
			accessor: "BuyersPartNumber",
			filter: "BuyersPartNumber",
			sortType: "basic",
			width: 180,
			isMandatory: true,
		},
		{
			Header: "Purchase Order Number",
			accessor: "PurchaseOrderNumber",
			filter: "PurchaseOrderNumber",
			sortType: "basic",
			width: 180,
			isMandatory: true,
		},
		{
			Header: "Measurement Qualifier",
			accessor: "MeasurementQualifier",
			filter: "MeasurementQualifier",
			sortType: "basic",
			width: 80,
			isMandatory: true,
		},
		{
			Header: "Measurement Value",
			accessor: "MeasurementValue",
			filter: "MeasurementValue",
			sortType: "basic",
			width: 80,
			isMandatory: true,
		},
		{
			Header: "Measurement Code",
			accessor: "MeasurementCode",
			filter: "MeasurementCode",
			sortType: "basic",
			width: 80,
			isMandatory: true,
		},
		{
			Header: "Reference Identification Qualifier",
			accessor: "ReferenceIdentificationQualifier",
			filter: "ReferenceIdentificationQualifier",
			sortType: "basic",
			width: 80,
			isMandatory: true,
		},
		{
			Header: "Reference Identification Qualifier Number",
			accessor: "ReferenceIdentificationQualifierNumber",
			filter: "ReferenceIdentificationQualifierNumber",
			sortType: "basic",
			width: 120,
			isMandatory: true,
		},
		{
			Header: "Line Item Count",
			accessor: "LineItemCount",
			filter: "LineItemCount",
			sortType: "basic",
			width: 80,
			isMandatory: false,
			isDiabled: true,
		},
	];

	useEffect(() => {
		setGridSales(salesData);
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		if (name === "CustomerID" || name === "MeasurementValue") {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setSaleItem((values) => ({
					...values,
					[name]: value.trim(),
				}));
			}
		} else {
			setSaleItem((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};

	const newhandleChange = (e) => {
		const { name, value } = e.target;
		if (name === "CustomerID" || name === "MeasurementValue") {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setNewSales((values) => ({
					...values,
					[name]: value.trim(),
				}));
			}
		} else {
			setNewSales((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};

	function deleteRecord(row) {
		console.log(row.row.original);
		let data = gridSales.filter((element, index) => {
			return index !== row.row.index;
		});
		const deletedData = Object.assign([], data);
		setGridSales(deletedData);
	}

	useEffect(() => {
		setSubmitDisable(validateForm());
	}, [newSales]);
	useEffect(() => {
		setAddSubmitDisable(validateEditForm());
	}, [sale]);

	const validateEditForm = () => {
		if (
			sale.ShippedTime &&
			sale.ShippedTime.toString().trim() !== "" &&
			sale.ShipToName &&
			sale.ShipToName.toString().trim() !== "" &&
			sale.CustomerID &&
			sale.CustomerID.toString().trim() !== "" &&
			sale.BuyersPartNumber &&
			sale.BuyersPartNumber.toString().trim() !== "" &&
			sale.PurchaseOrderNumber &&
			sale.PurchaseOrderNumber.toString().trim() !== "" &&
			sale.MeasurementQualifier &&
			sale.MeasurementQualifier.toString().trim() !== "" &&
			sale.MeasurementValue &&
			sale.MeasurementValue.toString().trim() !== "" &&
			(sale.MeasurementCode || sale.MeasurementCode === 0) &&
			sale.MeasurementCode.toString().trim() !== "" &&
			sale.ReferenceIdentificationQualifier &&
			sale.ReferenceIdentificationQualifier.toString().trim() !== "" &&
			sale.ReferenceIdentificationQualifierNumber &&
			sale.ReferenceIdentificationQualifierNumber.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};

	const validateForm = () => {
		if (
			newSales.ShippedTime &&
			newSales.ShippedTime.toString().trim() !== "" &&
			newSales.ShipToName &&
			newSales.ShipToName.toString().trim() !== "" &&
			newSales.CustomerID &&
			newSales.CustomerID.toString().trim() !== "" &&
			newSales.BuyersPartNumber &&
			newSales.BuyersPartNumber.toString().trim() !== "" &&
			newSales.PurchaseOrderNumber &&
			newSales.PurchaseOrderNumber.toString().trim() !== "" &&
			newSales.MeasurementQualifier &&
			newSales.MeasurementQualifier.toString().trim() !== "" &&
			(newSales.MeasurementValue || newSales.MeasurementValue === 0) &&
			newSales.MeasurementValue.toString().trim() !== "" &&
			newSales.MeasurementCode &&
			newSales.MeasurementCode.toString().trim() !== "" &&
			newSales.ReferenceIdentificationQualifier &&
			newSales.ReferenceIdentificationQualifier.toString().trim() !== "" &&
			newSales.ReferenceIdentificationQualifierNumber &&
			newSales.ReferenceIdentificationQualifierNumber.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};

	function saveRowHandler() {
		if (!editOrSaveInd) {
			newSales.ShippedDate = moment(
				newSales.ShippedDate ? newSales.ShippedDate : new Date()
			).format("MM/DD/YYYY");
			newSales.ind = Object.assign({}, gridSales.length + 1);
			newSales.ind = gridSales.length + 1;
			newSales.LineItemCount = newSales.LineItemCount
				? newSales.LineItemCount
				: 0;
			const ns = Object.assign({}, newSales);
			gridSales.unshift(ns);
			setaddShowConfirm(false);
			setNewSales(initialvalues);
			newSales.ind = 0;
		}
	}

	function editRowHandler() {
		let indicator = 0;
		sale.ShippedDate = moment(sale.ShippedDate).format("MM/DD/YYYY");

		if (editOrSaveInd) {
			gridSales.filter((element, index) => {
				if (editIndex === index) {
					const saletemp = Object.assign({}, sale);
					gridSales[index] = saletemp;
				}
			});
			indicator = 1;
		}

		if (indicator !== 0) {
			console.log(sale);
			setShowConfirm(false);
		}
	}

	const editReport = (sales) => {
		setEditIndex(sales.row.index);
		setSaleItem(
			{
				...sale,
				...sales.row.original,
			},
			setAddSubmitDisable(validateEditForm())
		);
		setShowConfirm(true);
		setEditOrSaveInd(true);
		setAddSubmitDisable(validateEditForm());
	};

	const saveRecords = () => {
		setaddShowConfirm(true);
		setEditOrSaveInd(false);
	};

	const saveallRecords = () => {
		setDisableSaveAll(true);
		gridSales.map((element) => {
			element.FileProcessID = salesData[0].FileProcessID;
			element.Service_Task_Id = outbounddata.ServiceTaskID;
			element.ModifiedOn = new Date();
			element.LastModifiedBy = JSON.parse(userData).UserName;
			element.IsResendRequired =
				outbounddata.FileSentStatus === "Sent" ? true : false;
			element.IsReadyforReversal = true;
			element.IsEdited = true;
			element.Version = 1;
		});

		setLoading(true);
		_HttpServices
			.postData("Api/Edi844/ReversalOutbound856", gridSales)
			.then((data) => {
				if (data.data === "") {
					setShowToaster(true);
					setTimeout(() => history.push("/outbound-reports"), 1000);
					setLoading(false);
				}
			})
			.catch((e) => {
				setLoading(false);
				setDisableSaveAll(false);
			});
	};

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<Toast
					onClose={() => setShowToaster(false)}
					show={showToaster}
					delay={1500}
					autohide
					className="custom-toaster"
				>
					<Toast.Body>Details updated successfully</Toast.Body>
				</Toast>
				<div>
					{!gridShow && (
						<Button
							variant="primary"
							type="button"
							onClick={() => saveRecords()}
						>
							Add Record
						</Button>
					)}
					<Button
						className="ml-2"
						type="submit"
						onClick={() => getExcel(Gridcolumns, gridSales, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>

				{/* Add New Record Modal */}
				<Modal
					show={addshowConfirm}
					onHide={() => setaddShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>Add Record</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											{/*dyn  */}
											<Row>
												{Gridcolumns.map(function (i, index) {
													return (
														i.accessor !== "accessor" && (
															<Col md={3} key={index}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label htmlFor="StartDate">
																			{/* Since */}
																			{i.accessor !== "accessor"
																				? i.Header
																				: ""}
																			{i.isMandatory && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.Header.indexOf("Date") !== -1 && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.Header.indexOf("Date") !== -1 && (
																			<DatePicker
																				key={newSales[i.accessor]}
																				selected={
																					newSales[i.accessor]
																						? new Date(
																								moment(
																									newSales[i.accessor]
																								).format("MM/DD/YYYY")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setNewSales((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={new Date()}
																			/>
																		)}
																		{i.Header.indexOf("Date") === -1 && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={newSales[i.accessor]}
																				key={sale[i.accessor]}
																				onChange={(e) => newhandleChange(e)}
																				disabled={i.isDiabled}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
											{/*  dyn*/}
										</Form>
									</div>
								</div>
							</Col>
						</Row>

						{/*  */}
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								type="submit"
								disabled={disableSubmit}
								onClick={() => saveRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Save
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => {
									setaddShowConfirm(false);
									setNewSales(initialvalues);
								}}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>

				{/* Edit Existing Record Modal */}
				<Modal
					show={showCOnfirm}
					onHide={() => setShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>
							{/* <span className="err-msg">{indicator && "please fill the fields"}</span> */}
							Edit Record
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											{/*dyn  */}
											<Row>
												{Gridcolumns.map(function (i, index) {
													return (
														i.accessor !== "accessor" && (
															<Col md={3} key={index}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label htmlFor="StartDate">
																			{/* Since */}
																			{i.accessor !== "accessor"
																				? i.Header
																				: ""}
																			{i.isMandatory && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.Header.indexOf("Date") !== -1 && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.Header.indexOf("Date") !== -1 && (
																			<DatePicker
																				key={sale[i.accessor]}
																				selected={
																					sale[i.accessor]
																						? new Date(
																								moment(sale[i.accessor]).format(
																									"MM/DD/YYYY"
																								)
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setSaleItem((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={new Date()}
																			/>
																		)}
																		{i.Header.indexOf("Date") === -1 && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={sale[i.accessor]}
																				// key={cont[i.accessor]}
																				onChange={(e) => handleChange(e)}
																				disabled={i.isDiabled}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
											{/*  dyn*/}
										</Form>
									</div>
								</div>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								disabled={addDisableSubmit}
								onClick={() => editRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Edit Row
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
			</div>

			{gridShow && (
				<Row>
					<Col md={12}>
						<div className="card pt-2">
							<div className="card-body">
								<div className="inventory-grid">
									{hasError ? (
										<p>Error occurred. Unable to load {fileName}</p>
									) : (
										<Fragment>
											{sales.length > 0 ? (
												<ReactTable
													columns={Gridcolumns}
													data={sales}
													defaultPageSize={10}
												/>
											) : (
												<div className="no-data">No data found.</div>
											)}
										</Fragment>
									)}
								</div>
							</div>
						</div>
					</Col>
				</Row>
			)}
			{!gridShow && (
				<Row>
					<Col md={12}>
						{/* <Row> */}
						<span className="mb-4 h6">
							File Name: {outbounddata.File_Process_Name}
						</span>{" "}
						<span className="ml-4 h6">Version: {outbounddata.Fileversion}</span>
						{/* </Row> */}
						<div className="card pt-2">
							<div className="card-body">
								<div className="inventory-grid">
									{hasError ? (
										<p>Error occurred. Unable to load {fileName}</p>
									) : (
										<Fragment>
											{gridSales.length > 0 ? (
												<ReactTable
													columns={Gridcolumns}
													data={gridSales}
													defaultPageSize={10}
												/>
											) : (
												<div className="no-data">No data found.</div>
											)}
										</Fragment>
									)}
								</div>
							</div>
						</div>
					</Col>
				</Row>
			)}
			{/*end  */}
			<Row>
				<Col md={12} className="text-right mt-2">
					{gridSales.length > 0 && (
						<Button
							variant="primary"
							type="button"
							disabled={disableSaveAll}
							onClick={() => saveallRecords()}
						>
							Save Records
						</Button>
					)}
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};

export default AdvanceShipEdiAddEdit;
